export const boardViewMapping: Record<string, string> = {
  '/nco': 'nco',
  '/projects': 'projects',
  '/website': 'website',
  '/mtb': 'mtb',
  '/deals': 'deals',
  '/organizations': 'organizations',
  '/contacts': 'contacts',
  '/leads': 'leads',
  '/teamtasks': 'teamtasks',
}
